import React, { useState, useEffect } from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";
import { styled } from "@mui/system";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useAvailableItemConfigContext } from "../../hooks/useContext/useAvailableItemConfigContext";
import useFetchOpenStatus from "../../hooks/useFetchOpenStatus";
import { useTranslation } from "../../hooks/useTranslation";

const Root = styled(Card)({
  height: "100%",
  backgroundColor: "white",
  p: 2,
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  position: "relative",
  overflow: "hidden",
});

const SolidLine = styled("div", {
  shouldForwardProp: (prop) => prop !== "isOpen",
})(({ theme, isOpen }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "4%",
  backgroundColor: isOpen
    ? theme.palette.primary.lighter
    : theme.palette.common.errorDarker,
  transition: "background-color 0.3s ease",
}));

export const OpenStatus = () => {
  const { openStatus, dispatch } = useAvailableItemConfigContext();
  const [isOpen, setIsOpen] = useState(openStatus ?? false);
  const { t } = useTranslation();

  useFetchOpenStatus();

  useEffect(() => {
    setIsOpen(openStatus);
  }, [openStatus]);

  const changeOpenStatus = async (isOpen) => {
    // console.log('Sending new open status to backend:', isOpen);
    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + "/api/user/updateOpenStatus", {
          method: "POST",
          headers: {
          "Content-Type": "application/json",
          },
          body: JSON.stringify({openStatus: isOpen}),
      });
      const newStatus = await response.json();
    //   console.log('new status: ' + newStatus);
      if (response.ok) {
        dispatch({ type: "SET_OPEN_STATUS", payload: newStatus });
        // console.log('open status changed');
        setIsOpen(newStatus);
      } else {
          console.log('error on OpenStatus.js page');
      } 
    } catch (error) {
      console.log(error);
    }
    console.log(isOpen);
  };

  const handleSwitchChange = (event) => {
    const newIsOpen = event.target.checked
    setIsOpen(newIsOpen);  // Update state based on switch position
    changeOpenStatus(newIsOpen);
  };


  return (
    <Root>
      <SolidLine isOpen={isOpen} />
      <CardContent>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="Center"
          spacing={0}
        >
          <FormGroup>
            <FormControlLabel
              labelPlacement="bottom"
              control={
                <Switch
                  checked={isOpen}
                  onChange={handleSwitchChange}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "primary.lighter",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "primary.lighter",
                    },
                    "& .MuiSwitch-switchBase": {
                      color: "common.errorDarker",
                    },
                    "& .MuiSwitch-track": {
                      backgroundColor: isOpen
                        ? "primary.lighter"
                        : "common.errorDarker",
                      opacity: 1,
                    },
                  }}
                />
              }
            />
          </FormGroup>
          <Typography
            variant="subtitle1"
            component="p"
            sx={{
              mt: 2,
              fontWeight: "bold",
              color: isOpen
                ? "primary.lighter"
                : "common.errorDarker",
            }}
          >
            {t('status')}: {isOpen ? t('open') : t('closed')}
          </Typography>
        </Stack>
      </CardContent>
    </Root>
  );
};
